import { Typography } from '@material-ui/core'
import React, { FunctionComponent } from 'react'
import SignatureModel from '../Models/SignatureModel'
import Signature from './Signature'

export interface HabeasDataProps {
  signatureData: SignatureModel
}

// tslint:disable-next-line:no-big-function
const HabeasData: FunctionComponent<HabeasDataProps> = ({ signatureData }) => {
  return (
    <div id='habeasData'>
      <div id='habeasDataDiv' style={{ maxHeight: '400px', overflowY: 'scroll' }}>
        <Typography component='h3' variant='h6' id='habeasDataHeader'>
          1. BASE LEGAL Y ÁMBITO DE APLICACIÓN
        </Typography>
        <br />
        <Typography component='p' variant='body2'>
          El derecho a la Protección de los Datos tiene como finalidad permitir a todas las personas conocer, actualizar
          y rectificar las informaciones que se hayan recogido sobre ellas en archivos o bases de datos. Este derecho
          constitucional se recoge en los artículos 15 y 20 de la Constitución Política; en la Ley Estatutaria 1581 de
          2012, por la cual se dictan disposiciones generales para la ley de Protección de Datos Personales (LEPD); y en
          el Decreto 1377 de 2013, por el cual se reglamenta parcialmente la Ley anterior.
        </Typography>
        <br />
        <Typography component='p' variant='body2'>
          Cuando el Titular de los datos presta su consentimiento para que estos formen parte de una base de datos de
          una organización u empresa, pública o privada, ésta se hace responsable del tratamiento de estos datos y
          adquiere una serie de obligaciones como son: la de tratar dichos datos con seguridad y cautela, velar por su
          integridad y aparecer como órgano a quien el Titular puede dirigirse para el seguimiento de la información y
          el control de la misma, pudiendo ejercitar los derechos de consultas y reclamos.
        </Typography>
        <br />
        <Typography component='p' variant='body2'>
          Si bien, la responsabilidad del tratamiento de los datos recae en la organización u empresa responsable del
          tratamiento, sus competencias se materializan en las funciones que corresponden a su personal de servicio. El
          personal de la organización u empresa responsable del tratamiento con acceso, directo o indirecto, a bases de
          datos que contienen datos personales han de conocer la normativa de protección de datos, la política de
          protección de datos de la empresa y el Manual Interno de Seguridad; y deben cumplir con las obligaciones en
          materia de seguridad de los datos correspondientes a sus funciones y cargo.
        </Typography>
        <br />
        <Typography component='p' variant='body2'>
          Para velar con el cumplimiento de sus obligaciones de seguridad,{' '}
          <Typography component='strong' variant='body2'>
            IMEDICAL SERVICES S.A.S.
          </Typography>
          , nombra a cuatro responsables de seguridad encargados de desarrollar, coordinar, controlar y verificar el
          cumplimiento de las medidas de seguridad recogidas en el Manual Interno de Seguridad.
        </Typography>
        <br />
        <Typography component='p' variant='body2'>
          Esta política será aplicable a todos los datos personales registrados en bases de datos que sean objeto de
          tratamiento por el responsable del tratamiento y se encuentra dirigida a todos los usuarios de datos, que son
          tanto el personal propio como al personal externo de{' '}
          <Typography component='strong' variant='body2'>
            IMEDICAL SERVICES S.A.S.
          </Typography>
        </Typography>
        <br />
        <Typography component='p' variant='body2'>
          Todos los usuarios identificados en el Manual Interno de Seguridad están obligados a cumplir con las medidas
          de seguridad establecidas para el tratamiento de los datos y están sujetos al deber de confidencialidad,
          incluso después de acabada su relación laboral o profesional con la organización o empresa responsable del
          tratamiento. El deber de confidencialidad, recogido en el artículo 4 literal h) de la ley de Protección de
          Datos (LEPD), se formaliza a través de la firma de un acuerdo de confidencialidad suscrito entre el usuario y
          el responsable del tratamiento.
        </Typography>
        <br />
        <Typography component='h3' variant='h6'>
          2. DEFINICIONES ESTABLECIDAS EN EL ARTÍCULO 3 DE LA LEY DE PROTECCIÓN DE DATOS PERSONALES (LEPD) Y EL ARTÍCULO
          3 DEL DECRETO 1377 DE 2013.
        </Typography>
        <br />
        <Typography component='ul'>
          <Typography component='li' variant='body2'>
            <Typography component='strong' variant='body2'>
              Autorización:{' '}
            </Typography>
            Consentimiento previo, expreso e informado del Titular para llevar a cabo el tratamiento de datos
            personales.
          </Typography>
          <br />
          <Typography component='li' variant='body2'>
            <Typography component='strong' variant='body2'>
              Base de Datos:{' '}
            </Typography>
            Conjunto organizado de datos personales que sea objeto de tratamiento.
          </Typography>
          <br />
          <Typography component='li' variant='body2'>
            <Typography component='strong' variant='body2'>
              Dato personal:{' '}
            </Typography>
            Cualquier información vinculada o que pueda asociarse a una o varias personas naturales determinadas o
            determinables.
          </Typography>
          <br />
          <Typography component='li' variant='body2'>
            <Typography component='strong' variant='body2'>
              Dato público:{' '}
            </Typography>
            Es el dato que no sea semiprivado, privado o sensible. Son considerados datos públicos, entre otros, los
            datos relativos al estado civil de las personas, a su profesión u oficio y a su calidad de comerciante o de
            servidor público. Por su naturaleza, los datos públicos pueden estar contenidos, entre otros, en registros
            públicos, documentos públicos, gacetas y boletines oficiales y sentencias judiciales debidamente
            ejecutoriadas que no estén sometidas a reserva.
          </Typography>
          <br />
          <Typography component='li' variant='body2'>
            <Typography component='strong' variant='body2'>
              Datos sensibles:{' '}
            </Typography>
            Se entiende por datos sensibles aquellos que afectan la intimidad del Titular o cuyo uso indebido puede
            generar su discriminación, tales como aquellos que revelen el origen racial o étnico, la orientación
            política, las convicciones religiosas o filosóficas, la pertenencia a sindicatos, organizaciones sociales,
            de derechos humanos o que promueva intereses de cualquier partido político o que garanticen los derechos y
            garantías de partidos políticos de oposición, así como los datos relativos a la salud, a la vida sexual, y
            los datos biométricos.
          </Typography>
          <br />
          <Typography component='li' variant='body2'>
            <Typography component='strong' variant='body2'>
              Encargado del tratamiento:{' '}
            </Typography>
            Persona natural o jurídica, pública o privada, que por sí misma o en asocio con otros, realice el
            tratamiento de datos personales por cuenta del responsable del tratamiento.
          </Typography>
          <br />
          <Typography component='li' variant='body2'>
            <Typography component='strong' variant='body2'>
              Responsable del tratamiento:{' '}
            </Typography>
            Persona natural o jurídica, pública o privada, que por sí misma o en asocio con otros, decida sobre la base
            de datos y/o el tratamiento de los datos.
          </Typography>
          <br />
          <Typography component='li' variant='body2'>
            <Typography component='strong' variant='body2'>
              Titular:{' '}
            </Typography>
            Persona natural cuyos datos personales sean objeto de tratamiento.
          </Typography>
          <br />
          <Typography component='li' variant='body2'>
            <Typography component='strong' variant='body2'>
              Tratamiento:{' '}
            </Typography>
            Cualquier operación o conjunto de operaciones sobre datos personales, tales como la recolección,
            almacenamiento, uso, circulación o supresión.
          </Typography>
          <br />
          <Typography component='li' variant='body2'>
            <Typography component='strong' variant='body2'>
              Aviso de privacidad:{' '}
            </Typography>
            Comunicación verbal o escrita generada por el responsable, dirigida al Titular para el tratamiento de sus
            datos personales, mediante la cual se le informa acerca de la existencia de las políticas de tratamiento de
            información que le serán aplicables, la forma de acceder a las mismas y las finalidades del tratamiento que
            se pretende dar a los datos personales.
          </Typography>
          <br />
          <Typography component='li' variant='body2'>
            <Typography component='strong' variant='body2'>
              Transferencia:{' '}
            </Typography>
            La transferencia de datos tiene lugar cuando el responsable y/o encargado del tratamiento de datos
            personales, ubicado en Colombia, envía la información o los datos personales a un receptor, que a su vez es
            responsable del tratamiento y se encuentra dentro o fuera del país.
          </Typography>
          <br />
          <Typography component='li' variant='body2'>
            <Typography component='strong' variant='body2'>
              Transmisión:{' '}
            </Typography>
            Tratamiento de datos personales que implica la comunicación de los mismos dentro o fuera del territorio de
            la República de Colombia cuando tenga por objeto la realización de un tratamiento por el encargado por
            cuenta del responsable.
          </Typography>
        </Typography>
        <br />
        <Typography component='h3' variant='h6'>
          3. PRINCIPIOS DE LA PROTECCIÓN DE DATOS
        </Typography>
        <br />
        <Typography component='p' variant='body2'>
          El artículo 4 de la Ley de Protección de Datos (LEPD), establece unos principios para el tratamiento de datos
          personales que se han de aplicar, de manera armónica e integral, en el desarrollo, interpretación y aplicación
          de la Ley. Los principios legales de la protección de datos son los siguientes:
        </Typography>
        <br />
        <Typography component='ul'>
          <Typography component='li' variant='body2'>
            <Typography component='strong' variant='body2'>
              Principio de legalidad:{' '}
            </Typography>
            El tratamiento de los datos es una actividad reglada que debe sujetarse a lo establecido en la Ley de
            Protección de Datos (LEPD), el Decreto 1377 de 2013 y en las demás disposiciones que la desarrollen.
          </Typography>
          <br />
          <Typography component='li' variant='body2'>
            <Typography component='strong' variant='body2'>
              Principio de finalidad:{' '}
            </Typography>
            El tratamiento debe obedecer a una finalidad legítima de acuerdo con la Constitución y la Ley, la cual debe
            ser informada al Titular.
          </Typography>
          <br />
          <Typography component='li' variant='body2'>
            <Typography component='strong' variant='body2'>
              Principio de libertad:{' '}
            </Typography>
            El tratamiento solo puede ejercerse con el consentimiento previo, expreso e informado del Titular. Los datos
            personales no podrán ser obtenidos o divulgados sin previa autorización, o en ausencia de mandato legal o
            judicial que revele el consentimiento. El tratamiento de los datos requiere la autorización previa e
            informada del Titular por cualquier medio que permita ser consultado con posterioridad, salvo en los
            siguientes casos que exceptúa el artículo 10 de la Ley de Protección de Datos (LEPD):
            <Typography component='ul'>
              <Typography component='li' variant='body2'>
                Información requerida por una entidad pública o administrativa en ejercicio de sus funciones legales o
                por orden judicial.
              </Typography>
              <br />
              <Typography component='li' variant='body2'>
                Datos de naturaleza pública.
              </Typography>
              <br />
              <Typography component='li' variant='body2'>
                Casos de urgencia médica o sanitaria.
              </Typography>
              <br />
              <Typography component='li' variant='body2'>
                Tratamiento de información autorizado por la Ley para fines históricos, estadísticos o científicos.
              </Typography>
              <br />
              <Typography component='li' variant='body2'>
                Datos relacionados con el Registro Civil de las personas.
              </Typography>
            </Typography>
          </Typography>
          <br />
          <Typography component='li' variant='body2'>
            <Typography component='strong' variant='body2'>
              Principio de veracidad o calidad:{' '}
            </Typography>
            La información sujeta a tratamiento debe ser veraz, completa, exacta, actualizada, comprobable y
            comprensible. Se prohíbe el tratamiento de datos parciales, incompletos, fraccionados o que induzcan a
            error.
          </Typography>
          <br />
          <Typography component='li' variant='body2'>
            <Typography component='strong' variant='body2'>
              Principio de transparencia:{' '}
            </Typography>
            En el tratamiento debe garantizarse el derecho del Titular a obtener del responsable del tratamiento o del
            encargado del tratamiento, en cualquier momento y sin restricciones, información acerca de la existencia de
            datos que le conciernan. En el momento de solicitar la autorización al titular, el responsable del
            tratamiento deberá informarle de manera clara y expresa lo siguiente, conservando prueba del cumplimiento de
            este deber:
            <Typography component='ul'>
              <Typography component='li' variant='body2'>
                El tratamiento al cual será sometidos sus datos y la finalidad del mismo.
              </Typography>
              <br />
              <Typography component='li' variant='body2'>
                El carácter facultativo de la respuesta del Titular a las preguntas que le sean hechas cuando éstas
                traten sobre datos sensibles o sobre datos de niños, niñas o adolescentes.
              </Typography>
              <br />
              <Typography component='li' variant='body2'>
                Los derechos que le asisten como Titular.
              </Typography>
              <br />
              <Typography component='li' variant='body2'>
                La identificación, dirección física, correo electrónico y teléfono del responsable del tratamiento.
              </Typography>
            </Typography>
          </Typography>
          <br />
          <Typography component='li' variant='body2'>
            <Typography component='strong' variant='body2'>
              Principio de acceso y circulación restringida:{' '}
            </Typography>
            El tratamiento se sujeta a los límites que se derivan de la naturaleza de los datos personales, de las
            disposiciones de la Ley de Protección de Datos (LEPD) y la Constitución. En este sentido, el tratamiento
            solo podrá hacerse por personas autorizadas por el titular y/o por las personas previstas en la Ley. Los
            datos personales, salvo la información pública, no podrán estar disponibles en internet y otros medios de
            divulgación o comunicación masiva, salvo que el acceso sea técnicamente controlable para brindar un
            conocimiento restringido solo a los Titulares o terceros autorizados conforme a la Ley.
          </Typography>
          <br />
          <Typography component='li' variant='body2'>
            <Typography component='strong' variant='body2'>
              Principio de seguridad:{' '}
            </Typography>
            La información sujeta a tratamiento por el responsable del tratamiento o encargado del tratamiento se deberá
            manejar con las medidas técnicas, humanas y administrativas que sean necesarias para otorgar seguridad a los
            registros evitando su adulteración, pérdida, consulta, uso o acceso no autorizado o fraudulento. El
            responsable del tratamiento tiene la responsabilidad de implantar las medidas de seguridad correspondientes
            y de ponerlas en conocimiento todo personal que tenga acceso, directo o indirecto, a los datos. Los usuarios
            que accedan a los sistemas de información del responsable del tratamiento deben conocer y cumplir con las
            normas y medidas de seguridad que correspondan a sus funciones. Estas normas y medidas de seguridad se
            recogen en el Manual Interno de Seguridad, de obligado cumplimiento para todo usuario y personal de la{' '}
            <Typography component='strong'>IMEDICAL SERVICES S.A.S.</Typography>, Cualquier modificación de las normas y
            medidas en materia de seguridad de datos personales por parte del responsable del tratamiento ha de ser
            puesta en conocimiento de los usuarios.
          </Typography>
          <br />
          <Typography component='li' variant='body2'>
            <Typography component='strong' variant='body2'>
              Principio de confidencialidad:{' '}
            </Typography>
            Todas las personas que intervengan en el tratamiento de datos personales que no tengan la naturaleza de
            públicos están obligadas a garantizar la reserva de la información, inclusive después de finalizada su
            relación con alguna de las labores que comprende el tratamiento, pudiendo solo realizar suministro o
            comunicación de datos personales cuando ello corresponda al desarrollo de las actividades autorizadas en la
            LEPD y en los términos de la misma.
          </Typography>
        </Typography>
        <br />
        <Typography component='h3' variant='h6'>
          4. CATEGORÍAS ESPECIALES DE DATOS
        </Typography>
        <Typography component='h4' variant='h6'>
          4.1. Datos sensibles
        </Typography>
        <br />
        <Typography component='p' variant='body2'>
          Los datos sensibles son aquellos que afectan la intimidad del Titular o cuyo uso indebido puede generar su
          discriminación, tales como aquellos que revelen el origen racial o étnico, la orientación política, las
          convicciones religiosas o filosóficas, la pertenencia a sindicatos, organizaciones sociales, de derechos
          humanos o que promueva intereses de cualquier partido político o que garanticen los derechos y garantías de
          partidos políticos de oposición así como los datos relativos a la salud, a la vida sexual y los datos
          biométricos.
        </Typography>
        <br />
        <Typography component='p' variant='body2'>
          Según el artículo 6 de la LEPD, se prohíbe el tratamiento de datos sensibles, excepto cuando:
        </Typography>
        <br />
        <Typography component='ul'>
          <Typography component='li' variant='body2'>
            El Titular haya dado su autorización explícita a dicho tratamiento, salvo en los casos que por ley no sea
            requerido el otorgamiento de dicha autorización.
          </Typography>
          <br />
          <Typography component='li' variant='body2'>
            El tratamiento sea necesario para salvaguardar el interés vital del Titular y éste se encuentre física o
            jurídicamente incapacitado. En estos eventos, los representantes legales deberán otorgar su autorización.
          </Typography>
          <br />
          <Typography component='li' variant='body2'>
            El tratamiento sea efectuado en el curso de las actividades legítimas y con las debidas garantías por parte
            de una fundación, ONG, asociación o cualquier otro organismo sin ánimo de lucro, cuya finalidad sea
            política, filosófica, religiosa o sindical, siempre que se refieran exclusivamente a sus miembros o a las
            personas que mantengan contactos regulares por razón de su finalidad. En estos eventos, los datos no se
            podrán suministrar a terceros sin la autorización del Titular.
          </Typography>
          <br />
          <Typography component='li' variant='body2'>
            El tratamiento se refiera a datos que sean necesarios para el reconocimiento, ejercicio o defensa de un
            derecho en un proceso judicial.
          </Typography>
          <br />
          <Typography component='li' variant='body2'>
            El tratamiento tenga una finalidad histórica, estadística o científica. En este evento deberán adoptarse las
            medidas conducentes a la supresión de identidad de los Titulares.
          </Typography>
        </Typography>
        <br />
        <Typography component='h4' variant='h6'>
          4.2. Derechos de los niños, niñas y adolescentes
        </Typography>
        <br />
        <Typography component='p' variant='body2'>
          El tratamiento de datos personales de niños, niñas y adolescentes está prohibido, excepto cuando se trate de
          datos de naturaleza pública, y cuando dicho tratamiento cumpla con los siguientes requisitos:
        </Typography>
        <br />
        <Typography component='ul'>
          <Typography component='li' variant='body2'>
            Que responda y respete el interés superior de los niños, niñas y adolescentes.
          </Typography>
          <br />
          <Typography component='li' variant='body2'>
            Que se asegure el respeto de sus derechos fundamentales
          </Typography>
        </Typography>
        <br />
        <Typography component='p' variant='body2'>
          Cumplidos los anteriores requisitos, el representante legal del niño, niña o adolescente otorgará la
          autorización previo ejercicio del menor a su derecho a ser escuchado, opinión que será valorada teniendo en
          cuenta la madurez, autonomía y capacidad para entender el asunto.
        </Typography>
        <br />
        <Typography component='p' variant='body2'>
          Es tarea del Estado y las entidades educativas de todo tipo proveer información y capacitar a los
          representantes legales y tutores sobre los eventuales riesgos a los que se enfrentan los niños, niñas y
          adolescentes respecto del tratamiento indebido de sus datos personales, y proveer de conocimiento acerca del
          uso responsable y seguro por parte de niños, niñas y adolescentes de sus datos personales, su derecho a la
          privacidad y protección de su información personal y la de los demás.
        </Typography>
        <br />
        <Typography component='p' variant='body2'>
          Todo responsable y encargado involucrado en el tratamiento de los datos personales de niños, niñas y
          adolescentes, deberá velar por el uso adecuado de los mismos, cumpliendo en todo momento con los principios y
          obligaciones recogidos en la LEPD y el Decreto 1377 de 2013. En todo caso, el tratamiento se asegurará el
          respeto a los derechos prevalentes de los niños, niñas y adolescentes.
        </Typography>
        <br />
        <Typography component='p' variant='body2'>
          Los derechos de acceso, corrección, supresión, revocación o reclamo por infracción sobre los datos de los
          niños, niñas adolescentes se ejercerán por las personas que estén facultadas para representarlos.
        </Typography>
        <br />
        <Typography component='h3' variant='h6'>
          5. FUNCIONES Y OBLIGACIONES
        </Typography>
        <Typography component='h4' variant='h6'>
          5.1. Responsable del tratamiento
        </Typography>
        <br />
        <Typography component='p' variant='body2'>
          Las obligaciones en materia de seguridad de los datos de{' '}
          <Typography component='strong'>IMEDICAL SERVICES S.A.S.</Typography>, son las siguientes:
        </Typography>
        <br />
        <Typography component='ul'>
          <Typography component='li' variant='body2'>
            Coordinar e implantar las medidas de seguridad recogidas en el Manual Interno de Seguridad.
          </Typography>
          <br />
          <Typography component='li' variant='body2'>
            Difundir el referido documento entre el personal afectado.
          </Typography>
          <br />
          <Typography component='li' variant='body2'>
            Mantener el Manual Interno de Seguridad actualizado y revisado siempre que se produzcan cambios relevantes
            en el sistema de información, el sistema de tratamiento, la organización de la empresa, el contenido de la
            información de las bases de datos, o como consecuencia de los controles periódicos realizados. De igual
            modo, se revisará su contenido cuando se produzca algún cambio que pueda afectar al cumplimiento de las
            medidas de seguridad.
          </Typography>
          <br />
          <Typography component='li' variant='body2'>
            Designar uno o más responsables de seguridad e identificar a los usuarios autorizados para acceder a las
            bases de datos en el Manual Interno de Seguridad.
          </Typography>
          <br />
          <Typography component='li' variant='body2'>
            Cuidar que el acceso mediante sistemas y aplicaciones informáticas se lleve a cabo mediante acceso
            identificado y contraseña.
          </Typography>
          <br />
          <Typography component='li' variant='body2'>
            Autorizar, salvo delegación expresa a usuarios autorizados e identificados en el Manual Interno de
            Seguridad, la salida de soportes fuera de los establecimientos donde se encuentran las bases de datos; las
            entradas y salidas de información por red, mediante dispositivos de almacenamiento electrónico o en papel y
            el uso de módems y las descargas de datos.
          </Typography>
          <br />
          <Typography component='li' variant='body2'>
            Verificar semestralmente la correcta aplicación del procedimiento de copias de respaldo y recuperación de
            datos.
          </Typography>
          <br />
          <Typography component='li' variant='body2'>
            Garantizar la existencia de una lista de usuarios autorizados y perfiles de usuario.
          </Typography>
          <br />
          <Typography component='li' variant='body2'>
            Asegurar la realización de una auditoría, interna, para verificar el cumplimiento de las medidas de
            seguridad en materia de protección de datos, al menos cada año.
          </Typography>
        </Typography>
        <br />
        <Typography component='h4' variant='h6'>
          5.2. Encargados de Seguridad
        </Typography>
        <br />
        <Typography component='p' variant='body2'>
          <Typography component='strong'>IMEDICAL SERVICES S.A.S.</Typography> designa como Encargados de seguridad de
          las bases de datos a:
        </Typography>
        <br />
        <Typography component='ul'>
          <Typography component='li' variant='body2'>
            Base de datos de Empleados: Directora General.
          </Typography>
          <br />
          <Typography component='li' variant='body2'>
            Base de datos de Proveedores: Directora General.
          </Typography>
          <br />
          <Typography component='li' variant='body2'>
            Base de datos de Clientes: Directora General.
          </Typography>
          <br />
          <Typography component='li' variant='body2'>
            Base de datos de visitantes: Directora General.
          </Typography>
        </Typography>
        <br />
        <Typography component='p' variant='body2'>
          Los encargados de seguridad tienen las siguientes funciones:
        </Typography>
        <br />
        <Typography component='ul'>
          <Typography component='li' variant='body2'>
            Base de datos de Empleados: Directora General.
          </Typography>
          <br />
          <Typography component='li' variant='body2'>
            Coordinar y controlar la implantación de las medidas de seguridad, y colaborar con el responsable del
            tratamiento en la difusión del Manual Interno de Seguridad.
          </Typography>
          <br />
          <Typography component='li' variant='body2'>
            Coordinar y controlar los mecanismos que permiten acceder a la información contenida en las bases de datos y
            elaborar un informe periódico sobre dicho control.
          </Typography>
          <br />
          <Typography component='li' variant='body2'>
            Gestionar los permisos de acceso a los datos por parte de los usuarios autorizados identificados en el
            Manual Interno de Seguridad.
          </Typography>
          <br />
          <Typography component='li' variant='body2'>
            Habilitar el registro de incidencias a todos los usuarios para que comuniquen y registren las incidencias
            relacionadas con la seguridad de los datos; así como acordar con el responsable del tratamiento las medidas
            correctoras y registrarlas.
          </Typography>
          <br />
          <Typography component='li' variant='body2'>
            Comprobar periódicamente, la validez y vigencia de la lista de usuarios autorizados, la existencia y validez
            de las copias de seguridad para la recuperación de los datos, la actualización del Manual Interno de
            Seguridad y el cumplimiento de las medidas relacionadas con las entradas y salidas de datos.
          </Typography>
          <br />
          <Typography component='li' variant='body2'>
            Definir los tiempos dentro de los cuales se realizaran las auditorias, los cuales no podrán ser superiores a
            un año.
          </Typography>
          <br />
          <Typography component='li' variant='body2'>
            Recibir y analizar el informe de auditoría para elevar sus conclusiones y proponer medidas correctoras al
            responsable del tratamiento.
          </Typography>
          <br />
          <Typography component='li' variant='body2'>
            Gestionar y controlar los registros de entradas y salidas de documentos o soportes que contengan datos
            personales.
          </Typography>
        </Typography>
        <br />
        <Typography component='h4' variant='h6'>
          5.3. Usuarios
        </Typography>
        <br />
        <Typography component='p' variant='body2'>
          Todas las personas que intervienen en el almacenamiento, tratamiento, consulta o cualquier otra actividad
          relacionada con los datos personales y sistemas de información de{' '}
          <Typography component='strong'>IMEDICAL SERVICES S.A.S.</Typography>, deben actuar de conformidad a las
          funciones y obligaciones recogidas en el presente apartado.
        </Typography>
        <br />
        <Typography component='p' variant='body2'>
          <Typography component='strong'>IMEDICAL SERVICES S.A.S.</Typography>, cumple con el deber de información con
          su inclusión de acuerdos de confidencialidad y deber de secreto que suscriben, en su caso, los usuarios de
          sistemas de identificación sobre bases de datos y sistemas de información, y mediante una circular informativa
          dirigida a los mismos.
        </Typography>
        <br />
        <Typography component='p' variant='body2'>
          Las funciones y obligaciones del personal de{' '}
          <Typography component='strong'>IMEDICAL SERVICES S.A.S.</Typography>, se definen, con carácter general, según
          el tipo de actividad que desarrollan dentro de la empresa y, específicamente, por el contenido de este Manual.
          La lista de usuarios y perfiles con acceso a los recursos protegidos están recogidos en el Manual Interno de
          Seguridad. Con carácter general, cuando un usuario trate documentos o soportes que contiene datos personales
          tiene el deber de custodiarlos, así como de vigilar y controlar que personas no autorizadas no puedan tener
          acceso a ellos.
        </Typography>
        <br />
        <Typography component='p' variant='body2'>
          El incumplimiento de las obligaciones y medidas de seguridad establecidas en este Manual por parte del
          personal al servicio de <Typography component='strong'>IMEDICAL SERVICES S.A.S.</Typography>, es sancionable
          de acuerdo a la normativa aplicable a la relación jurídica existente entre el usuario y{' '}
          <Typography component='strong'>IMEDICAL SERVICES S.A.S.</Typography>
        </Typography>
        <br />
        <Typography component='p' variant='body2'>
          Las funciones y obligaciones de los usuarios de las bases de datos personales bajo responsabilidad de IMEDICAL
          SERVICES S.A.S., son las siguientes:
        </Typography>
        <br />
        <Typography component='ul'>
          <Typography component='li' variant='body2'>
            Base de datos de Empleados: Directora General.
          </Typography>
          <br />
          <Typography component='li' variant='body2'>
            <Typography component='strong' variant='body2'>
              DEBER DE SECRETO:{' '}
            </Typography>
            Aplica a todas las personas que, en el desarrollo de su profesión o trabajo, acceden a bases de datos
            personales y vincula tanto a usuarios como a prestadores de servicios contratados; en cumplimiento de este
            deber, los usuarios de <Typography component='strong'>IMEDICAL SERVICES S.A.S.</Typography>, no pueden
            comunicar o relevar a terceras personas, datos que manejen o de los que tengan conocimiento en el desempeño
            o cargo de sus funciones, y deben velar por la confidencialidad e integridad de los mismos.
          </Typography>
          <br />
          <Typography component='li' variant='body2'>
            <Typography component='strong' variant='body2'>
              FUNCIONES DE CONTROL Y AUTORIZACIONES DELEGADAS:{' '}
            </Typography>
            El responsable del tratamiento puede delegar el tratamiento de datos a terceros, para que actúe como
            encargado del tratamiento, mediante un contrato de transmisión de datos.
          </Typography>
          <br />
          <Typography component='li' variant='body2'>
            <Typography component='strong' variant='body2'>
              OBLIGACIONES RELACIONADAS CON LAS MEDIDAS DE SEGURIDAD IMPLANTADAS:{' '}
            </Typography>
            <Typography component='ul'>
              <Typography component='li' variant='body2'>
                Acceder a las bases de datos solamente con la debida autorización y cuando sea necesario para el
                ejercicio de sus funciones.
              </Typography>
              <br />
              <Typography component='li' variant='body2'>
                No revelar información a terceras personas ni a usuarios no autorizados.
              </Typography>
              <br />
              <Typography component='li' variant='body2'>
                Observar las normas de seguridad y trabajar para mejorarlas.
              </Typography>
              <br />
              <Typography component='li' variant='body2'>
                No realizar acciones que supongan un peligro para la seguridad de la información.
              </Typography>
              <br />
              <Typography component='li' variant='body2'>
                No sacar información de las instalaciones de la organización sin la debida autorización.
              </Typography>
              <br />
            </Typography>
          </Typography>
          <br />
          <Typography component='li' variant='body2'>
            <Typography component='strong' variant='body2'>
              USO DE RECURSOS Y MATERIALES DE TRABAJO:{' '}
            </Typography>
            Debe estar orientado al ejercicio de las funciones asignadas. No se autoriza el uso de estos recursos y
            materiales para fines personales o ajenos a las tareas correspondientes al puesto de trabajo. Cuando, por
            motivos justificados de trabajo, sea necesaria la salida de dispositivos periféricos o extraíbles, deberá
            comunicarse al responsable de seguridad correspondiente que podrá autorizarla y, en su caso, registrarla.
          </Typography>
          <br />
          <Typography component='li' variant='body2'>
            <Typography component='strong' variant='body2'>
              USO DE IMPRESORAS, ESCÁNERES Y OTROS DISPOSITIVOS DE COPIA:{' '}
            </Typography>
            Cuando se utilicen este tipo de dispositivos debe procederse a la recogida inmediata de las copias, evitando
            dejar éstas en las bandejas de los mismos.
          </Typography>
          <br />
          <Typography component='li' variant='body2'>
            <Typography component='strong' variant='body2'>
              OBLIGACIÓN DE NOTIFICAR INCIDENCIAS:{' '}
            </Typography>
            Los usuarios tienen la obligación de notificar las incidencias de las que tenga conocimiento al responsable
            de seguridad que corresponda, quien se encargará de su gestión y resolución. Algunos ejemplos de incidencias
            son: la caída del sistema de seguridad informática que permita el acceso a los datos personales a personas
            no autorizadas, el intento no autorizado de la salida de un documento o soporte, la pérdida de datos o la
            destrucción total o parcial de soportes, el cambio de ubicación física de bases de datos, el conocimiento
            por terceras personas de contraseñas, la modificación de datos por personal no autorizado, etc.
          </Typography>
          <br />
          <Typography component='li' variant='body2'>
            <Typography component='strong' variant='body2'>
              DEBER DE CUSTODIA DE LOS SOPORTES UTILIZADOS:{' '}
            </Typography>
            Obliga al usuario autorizado a vigilar y controlar que personas no autorizadas accedan a la información
            contenida en los soportes. Los soportes que contienen bases de datos deben identificar el tipo de
            información que contienen mediante un sistema de etiquetado y ser inventariados. Cuando la información esté
            clasificada con nivel de seguridad sensible el sistema de etiquetado solo debe ser comprensible para los
            usuarios autorizados a acceder a dicha información.
          </Typography>
          <br />
          <Typography component='li' variant='body2'>
            <Typography component='strong' variant='body2'>
              RESPONSABILIDAD SOBRE LOS TERMINALES DE TRABAJO Y PORTÁTILES:{' '}
            </Typography>
            Cada usuario es responsable de su propio terminal de trabajo; cuando esté ausente de su puesto, debe
            bloquear dicho terminal (ej. protector de pantalla con contraseña) para impedir la visualización o el acceso
            a la información que contiene; y tiene el deber de apagar el terminal al finalizar la jornada laboral.
            Asimismo, los ordenadores portátiles han de estar controlados en todo momento para evitar su pérdida o
            sustracción.
          </Typography>
          <br />
          <Typography component='li' variant='body2'>
            <Typography component='strong' variant='body2'>
              USO LIMITADO DE INTERNET Y CORREO ELECTRÓNICO:{' '}
            </Typography>
            El envío de información por vía electrónica y el uso de Internet por parte del personal está limitado al
            desempeño de sus actividades en la empresa.
          </Typography>
          <br />
          <Typography component='li' variant='body2'>
            <Typography component='strong' variant='body2'>
              SALVAGUARDA Y PROTECCIÓN DE CONTRASEÑAS:{' '}
            </Typography>
            Las contraseñas proporcionadas a los usuarios son personales e intransferibles, por lo que se prohíbe su
            divulgación o comunicación a personas no autorizadas. Cuando el usuario accede por primera vez con la
            contraseña asignada es necesario que la cambie.
          </Typography>
          <br />
        </Typography>
        <br />
        <Typography component='p' variant='body2'>
          Cuando sea necesario restaurar la contraseña, el usuario debe comunicarlo al administrador del sistema.
        </Typography>
        <br />
        <Typography component='ul'>
          <Typography component='li' variant='body2'>
            <Typography component='strong' variant='body2'>
              COPIAS DE RESPALDO Y RECUPERACIÓN DE DATOS:{' '}
            </Typography>
            Debe realizarse copia de seguridad de toda la información de bases de datos personales de la empresa.
          </Typography>
          <br />
          <Typography component='li' variant='body2'>
            <Typography component='strong' variant='body2'>
              DEBER DE ARCHIVO Y GESTIÓN DE DOCUMENTOS Y SOPORTES:{' '}
            </Typography>
            Los documentos y soportes deben de ser debidamente archivados con las medidas de seguridad recogidas en el
            Manual de Políticas y Procedimiento y en el Manual Interno de Seguridad.
          </Typography>
        </Typography>
        <br />
        <Typography component='h3' variant='h6'>
          6. VIGENCIA
        </Typography>
        <br />
        <Typography component='p' variant='body2'>
          El presente Manual rige a partir del 01 de enero de 2019. La Empresa podrá modificar los términos y
          condiciones de la presente política para cumplir con las obligaciones establecidas por la Ley 1581 de 2012,
          los decretos reglamentarios y demás normas que complementen modifiquen o deroguen esta política. En los casos
          que esto ocurra se publicará la nueva política en la página web y en nuestra sede.
        </Typography>
        <br />
        <Signature data={signatureData} />
      </div>
    </div>
  )
}

export default HabeasData
